import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RatingService } from '../services/rating-service';

export interface UnifiedReview {
  id: string;
  source: 'App Store' | 'Play Store';
  author: string;
  rating: number;
  title?: string;
  content: string;
  date: Date;
}

@Component({
  selector: 'app-reviews',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './reviews.component.html',
  styleUrl: './reviews.component.css'
})
export class ReviewsComponent implements OnInit {
  private ratingService = inject(RatingService);

  appStoreReviews: UnifiedReview[] = [];
  playStoreReviews: UnifiedReview[] = [];
  loading = true;

  async ngOnInit() {
    try {
      this.loading = true;
      const [appReviews, playReviews] = await Promise.all([
        this.ratingService.getAppStoreReviews(),
        this.ratingService.getPlayStoreReviews()
      ]);

      console.log('App Store Reviews Original:', appReviews);
      console.log('Play Store Reviews Original:', playReviews);

      this.appStoreReviews = (appReviews?.reviews || []).map(this.mapAppStoreReview);
      this.playStoreReviews = (playReviews?.reviews || []).map(this.mapPlayStoreReview);

    } catch (error) {
      console.error('Error fetching reviews:', error);
    } finally {
      this.loading = false;
    }
  }

  private mapAppStoreReview(review: any): UnifiedReview {
    const attr = review.attributes || {};
    return {
      id: review.id,
      source: 'App Store',
      author: attr.reviewerNickname || 'Anonymous',
      rating: attr.rating || 0,
      title: attr.title,
      content: attr.body || '',
      date: new Date(attr.createdDate)
    };
  }

  private mapPlayStoreReview(review: any): UnifiedReview {
    // Play Store structure usually has comments array
    const comment = review.comments?.[0]?.userComment || {};
    return {
      id: review.reviewId,
      source: 'Play Store',
      author: review.authorName || 'Anonymous',
      rating: comment.starRating || 0,
      content: comment.text || '',
      date: new Date(parseInt(comment.lastModified?.seconds || '0') * 1000)
    };
  }
}
